import { render, staticRenderFns } from "./ProWelcome.vue?vue&type=template&id=27108fb4&scoped=true&"
import script from "./ProWelcome.vue?vue&type=script&lang=js&"
export * from "./ProWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27108fb4",
  null
  
)

export default component.exports